import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import timestamps from '~/services/timestamps'
import TextEdit from '~/services/textedit'


export default class extends React.Component {
    static propTypes = {
		articles: PropTypes.array.isRequired,
		interest: PropTypes.object.isRequired
	};

    articleImage = (article) => {
		let completed = article.post_type.singular === 'workshop' && article.completed;

		return <Link to={article.link}>
			<div className={`story-preview__img ${completed ? 'overlay' : ''}`}>
				<img src={article.images.thumbnail} className="img-responsive" />
				{ completed && <i className="text-light-success icon-check" /> }
			</div>
		</Link>
	};

    articleDisplay = (article, imageTop) => {
		if( !article ) return
		return <div className="col-sm-6 col-xs-12 story-preview">
			{ imageTop && this.articleImage(article) }
			<div className="content-holder bg-white p10">
				<h5 className="mtop0 mbot10">
					<Link to={article.link} state={{article: article}} className="text-dark-gray">
		    			{ article.title }
					</Link>
				</h5>
				<p className="minimal details">
					{'Posted ' + timestamps.timeSince(article.date, true) + ' | ' + article.read_time + ' min read'}
				</p>
			</div>
			{ !imageTop && this.articleImage(article) }
		</div>
	};

    render() {

		return (
			<div className="interest-grid narrow-gutter">

				<div className="grid-half row">
	            	{ this.articleDisplay( this.props.articles[0], false ) }
	            	{ this.articleDisplay( this.props.articles[1], false ) }
            	</div>

            	{ 'title' in this.props.interest && <div className="hidden-xs interest-circle"><p>{this.props.interest.title}</p></div> }
            	<div className="clearfix"></div>

				<div className="grid-half row">
	            	{ this.articleDisplay( this.props.articles[2], true ) }
	            	{ this.articleDisplay( this.props.articles[3], true ) }	
            	</div>

			</div>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/components/InterestCluster.jsx